module.exports = __webpack_public_path__ + "static/media/closeIcon.921c0bff.svg";